import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FormlyModule } from '@ngx-formly/core';

import { TaFormlyFieldWrapperModule } from '@ta-formly/ta-field-wrapper/ta-field-wrapper.module';
import { TaFuelGaugeComponent } from './ta-fuel-gauge.type';

@NgModule({
    declarations: [TaFuelGaugeComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IonicModule,
        TaFormlyFieldWrapperModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-fuel-gauge',
                    component: TaFuelGaugeComponent,
                    wrappers: ['ta-field-wrapper']
                }
            ]
        })
    ]
})
export class TaFormlyFuelGaugeModule { }
